import * as React from 'react';
import styled from 'styled-components';

import { styles } from '@/components/v2/UtilityCss/Animation';

import { ReactComponent as MarkSplat } from '../../images/illustrations/marks/mark-splat.svg';
import { INTERNAL_LINKS, SIGNUP_LINK } from '../../utils';
import { Button, GradientHeader, Text } from '../design-system';
import { GRID_SIZE } from '../global/PaperGrid';

import { WorkflowsTout } from './WorkflowsTout';

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  padding-bottom: 100px;

  &::after {
    z-index: 0;
    pointer-events: none;
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: -20px;
    background-image: linear-gradient(
        ${({ theme }) => theme.borderColor.MUTED} 1px,
        transparent 1px
      ),
      linear-gradient(
        to right,
        ${({ theme }) => theme.borderColor.MUTED} 1px,
        transparent 1px
      );
    background-size: ${GRID_SIZE}px ${GRID_SIZE}px;
    background-position: top center;
    mask: linear-gradient(
      180deg,
      transparent 0%,
      white 50%,
      white 85%,
      transparent 100%
    );
  }
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${({ theme }) => theme.maxWidth.PAGE};
  padding: 0 ${GRID_SIZE}px;
  gap: 56px;
  margin: 0 auto;
  z-index: 1;
  position: relative;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    gap: 50px;
  }
`;

const Top = styled.div`
  display: flex;
  align-items: center;
  gap: 102px;
  margin: 0 auto;
  max-width: 883px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    flex-direction: column;
    gap: 20px;
  }
`;

const StyledHeader = styled(GradientHeader)`
  && {
    text-align: left;
    position: relative;

    @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
      padding-right: 30px;
    }

    svg {
      position: absolute;
      bottom: -4px;
      right: -23px;

      @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
        display: none;
      }
    }
  }
`;

const Left = styled.div``;

const Right = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

const Actions = styled.div`
  display: flex;
  gap: 20px;
`;

export const HeroTout: React.ComponentType = React.memo(() => {
  return (
    <Wrapper className={styles.heroFadeIn}>
      <Inner>
        <Top>
          <Left>
            <StyledHeader renderAs="h0">
              Bring everyone together with data
              <MarkSplat />
            </StyledHeader>
          </Left>
          <Right>
            <Text
              css={`
                margin-bottom: 0;
              `}
              size="extra-large">
              Go end-to-end from quick queries to deep-dive analyses to
              beautiful interactive data apps – all in one collaborative,
              AI-powered workspace.
            </Text>
            <Actions>
              <Button
                link={`${SIGNUP_LINK}?source=hero`}
                size="large"
                stylez="loud"
                text="Get started for free"
              />
              <Button
                link={INTERNAL_LINKS.RequestADemo}
                size="large"
                text="Request a demo"
              />
            </Actions>
          </Right>
        </Top>
        <WorkflowsTout />
      </Inner>
    </Wrapper>
  );
});
